// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: 'Poppins', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: 'Poppins', sans-serif;
}

/* ----------------carousel -------------- */
.carousel {
  margin: 50px auto;
}

.carousel .item {
  color: #999;
  overflow: hidden;
  min-height: 120px;
  font-size: 13px;
}


.carousel img {
  width: 75px;
  height: 75px;
  display: block;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border: 2px solid #fff;
  object-fit: contain;
}

.carousel .testimonial {
  font-weight: 400;
  line-height: 28px;
  text-align: left;
  color: rgba(17, 24, 39, 1);

}

.carousel .testimonial p {
  line-height: 21px;
  margin: 0;
  display: flex;
  gap: 10px;
}

.carousel .overview .details {
  padding: 5px 0 8px;
}

.carousel .overview b {
  text-transform: uppercase;
  color: #111827;
}

.carousel .carousel-control {
  width: 30px;
  height: 30px;
  background: #666;
  text-shadow: none;
  top: 4px;
}

.carousel-control.left {
  left: auto;
  right: 40px;
}

.carousel-control.right {
  left: auto;
}

.carousel-indicators {
  bottom: -80px !important;
}

.carousel-indicators li,
.carousel-indicators li.active {
  width: 18px !important;
  height: 18px !important;
  border-radius: 0 !important;
  margin: 1px 4px !important;
}
.carousel-indicators li {
  background: #e2e2e2 !important;
  border: 4px solid #fff !important;
  border-radius: 100% !important;
}

.carousel-indicators li.active {
  color: #fff !important;
  border: 5px solid !important;
  border-radius: 100% !important;
  background: linear-gradient(90.67deg, #ED3237 3.01%, #F08F21 99.49%) !important;

}

.item>.row>div {
  width: 573px !important;
  /* height: 276px; */
  padding: 32px;
  border-radius: 40px;
  box-shadow: 0px 4px 8px 3px rgba(0, 0, 0, 0.04);
  margin: 15px 0px;
}

.quotemark {
  width: 15.93px !important;
  height: 13px !important;
  border: none !important;
  box-shadow: none !important;
}
label{
  font-size: 1.5rem !important;
}
.contact-us input{
  font-size: 1.5rem !important;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,4CAA4C;AAC5C;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,wCAAwC;EACxC,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;;AAE5B;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,8BAA8B;EAC9B,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,8BAA8B;EAC9B,+EAA+E;;AAEjF;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B","sourcesContent":["body {\n  margin: 0;\n  font-family: 'Poppins', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: 'Poppins', sans-serif;\n}\n\n/* ----------------carousel -------------- */\n.carousel {\n  margin: 50px auto;\n}\n\n.carousel .item {\n  color: #999;\n  overflow: hidden;\n  min-height: 120px;\n  font-size: 13px;\n}\n\n\n.carousel img {\n  width: 75px;\n  height: 75px;\n  display: block;\n  border-radius: 50%;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n  border: 2px solid #fff;\n  object-fit: contain;\n}\n\n.carousel .testimonial {\n  font-weight: 400;\n  line-height: 28px;\n  text-align: left;\n  color: rgba(17, 24, 39, 1);\n\n}\n\n.carousel .testimonial p {\n  line-height: 21px;\n  margin: 0;\n  display: flex;\n  gap: 10px;\n}\n\n.carousel .overview .details {\n  padding: 5px 0 8px;\n}\n\n.carousel .overview b {\n  text-transform: uppercase;\n  color: #111827;\n}\n\n.carousel .carousel-control {\n  width: 30px;\n  height: 30px;\n  background: #666;\n  text-shadow: none;\n  top: 4px;\n}\n\n.carousel-control.left {\n  left: auto;\n  right: 40px;\n}\n\n.carousel-control.right {\n  left: auto;\n}\n\n.carousel-indicators {\n  bottom: -80px !important;\n}\n\n.carousel-indicators li,\n.carousel-indicators li.active {\n  width: 18px !important;\n  height: 18px !important;\n  border-radius: 0 !important;\n  margin: 1px 4px !important;\n}\n.carousel-indicators li {\n  background: #e2e2e2 !important;\n  border: 4px solid #fff !important;\n  border-radius: 100% !important;\n}\n\n.carousel-indicators li.active {\n  color: #fff !important;\n  border: 5px solid !important;\n  border-radius: 100% !important;\n  background: linear-gradient(90.67deg, #ED3237 3.01%, #F08F21 99.49%) !important;\n\n}\n\n.item>.row>div {\n  width: 573px !important;\n  /* height: 276px; */\n  padding: 32px;\n  border-radius: 40px;\n  box-shadow: 0px 4px 8px 3px rgba(0, 0, 0, 0.04);\n  margin: 15px 0px;\n}\n\n.quotemark {\n  width: 15.93px !important;\n  height: 13px !important;\n  border: none !important;\n  box-shadow: none !important;\n}\nlabel{\n  font-size: 1.5rem !important;\n}\n.contact-us input{\n  font-size: 1.5rem !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
